<template>

    <form @submit.prevent="sendData('insert', filedataformlist)" action="" class="insertmediadata"  method="post" aria-describedby="Create Media" enctype="multipart/form-data" autocomplete="on">

        <div class="mb-3">
            <label for="filealtmediainsert" class="form-label">File Alt</label>
            <input 
                type="text" 
                v-model="filealt" 
                class="form-control" 
                id="filealtmediainsert" 
                aria-describedby="File Alt"
                @focusin="inputValidation()"
                @focusout="inputValidation()"
            >
        </div>

        <div class="mb-3">
            <label for="filesmediainsert" class="form-label">File</label>
            <input 
                @change="multipleFileData($event)" 
                class="form-control files" 
                name="files" 
                type="file" 
                id="filesmediainsert" 
                accept="image/*" 
                ref="inputfile"
            >
        </div>
     
        <button type="submit" class="btn btn-primary" :disabled="disabled">Submit</button>

    </form>

</template>
<script>

import fetchData from './../../fetchData.js';
import validation from './../../validationInputs.js';


//Set Use Strict
"use strict";

export default{
    name: 'MediaInsertElement',
    props:{

        csrftolken:{
            type: String,
            required: true
        },
        mediainsert:{
            type: String,
            required: true
        },
        modalclassname:{
            type: String,
            required: true
        },
        responseclassname:{
            type: String,
            required: true
        },
        removeresponsemessages:{
            type: Function,
            required: true
        },
        checklocalstorage:{
            type: Function,
            required: true
        }

    },  
    data: () => {

        return {

            disabled: false,
            filealt: '',
            alertgigabyte: 1024 * 1024 * 1000 * 2,
            filedataformlist: [],
            filedataformitemlist: {},
            filewidthheightlist: [],
            activeclass: 'd-flex',
            alertmegabyte: 1024 * 1000 * 1.5

        }

    },
    methods:{

        hideModal(classname){

            //Hide Modal
            $(`.${classname}`).modal("hide");

            return;

        },
        dataStructureResponse(responseObject){

            //Get Key and Value
            let entries = Object.entries(responseObject);

            //Response Value

            //Loop response conditional
            for(const [key, value] of entries){

                switch(key)
                {

                    case 'attListDataMedia':

                        //Set Data
                        let mediaData = JSON.parse(value);

                        //Remove LocalStorage
                        localStorage.removeItem('medialist');

                        //Set New Values for Media List
                        localStorage.setItem('medialist', JSON.stringify(mediaData));

                    break;

                    case 'attListDataLogotipoMedia':

                        //Set Data
                        let logotipoData = JSON.parse(value);

                        //Remove LocalStorage
                        localStorage.removeItem('logotipolist');

                        //Set New Values for Media List
                        localStorage.setItem('logotipolist', JSON.stringify(logotipoData));

                    break;

                    case 'successMessage':
                    case 'errorMessage':
                        
                        //Add active Class
                        document.querySelector(`.${this.responseclassname}`).classList.add(this.activeclass);
                        document.querySelector(`.${this.responseclassname}`).classList.add(key.toLowerCase());

                        //Set Messages List
                        value.forEach((valmessage) => {

                            //Element for append
                            let li = `<li class="list-group item my-1">${valmessage}</li>`;

                            //Append Element
                            $(li).appendTo(document.querySelector(`.${this.responseclassname}`).children);

                        });
                        
                    break;

                }

            }

            //Clean Data
            this.filealt = '';

            //Clean Variable from file action
            this.filedataformitemlist = {};
            this.filedataformlist = [];
            this.filewidthheightlist = [];

            //Att Media List
            this.checklocalstorage();

            //Close Modal
            this.hideModal(this.modalclassname);

            //Remove disabled from files
            document.querySelector('.files').removeAttribute('disabled');

            //Clean values from files
            document.querySelector('.files').value = "";

            //Enable BTN
            this.disabled = false;

            //Remove Base Response Message
            this.removeresponsemessages();

            return;

        },
        inputValidation(){

            //File Alt Input validation
            if(this.filealt && !validation.validNameCases(10, this.filealt)){

                //Show Error Message
                validation.createErrorMessageElement('filealtmediainsert', 'Favor informar dados válidos');

                //Disabled Submit button
                this.disabled = true;

                return;

            }else{

                //Enabled Submit button
                this.disabled = false;

                return;

            }

        },
        multipleFileData(element){

            //Set Disabled
            element.target.setAttribute('disabled', true);

            //FileData Item Object Clean Variable
            this.filedataformitemlist = {};

            //Get Data from File
            let filedata = element.target.files;

            //Get Data from Multiple File
            [...filedata].forEach((value, index) => {

                //Check fileSize
                if(value.size >= Math.abs(this.alertmegabyte)){

                    alert('Please upload a smaller file up to 1MG');

                    //Enabled Input
                    element.target.removeAttribute('disabled');

                    //Disabled Submit button
                    //this.disabled = true;

                    return;

                }

                //Check type of the file
                if(!value.type.includes('image')){

                    alert('Please only send image type file');

                    //Disabled Submit button
                    //this.disabled = true;

                    return;

                }

                //Structure File Data Object
                this.filedataformitemlist = {
                    fileindex: index,
                    filename: value.name.trim(),
                    filedata: {}
                };

                //Get Width and Height from Image
                let reader = new FileReader();
                    reader.readAsDataURL(value);
                    reader.onload = e => {

                        const src = e.target.result;

                        const img = new Image();

                        img.onload = () => {

                            //Set FileDimension
                            let filedimension = {
                                width: img.width,
                                height: img.height
                            };

                            //Set File width and height
                            this.filewidthheightlist.push(filedimension);

                            return this.filewidthheightlist; 

                        };

                        img.onerror = (error) => {
                            
                            throw new Error(error)

                        };

                        img.src = src;

                    }; 

                //Get base64 Promise
                let file64Promise = fetchData.toBase64(value);

                //Get Data from Promise
                file64Promise.then((val64) => {

                    //Check File Alt
                    let filealtname = this.filealt ? this.filealt : value.name.trim().replace(value.type.replace("image/", ""), '').toLowerCase();

                    //Structure File Data Object
                    this.filedataformitemlist.filedata = {
                        type: value.type.replace("image/", ""),
                        filealt: filealtname.trim(),
                        file64: val64,
                        filealldimensions: this.filewidthheightlist[index] ? this.filewidthheightlist[index] : null
                    };

                    //Push Data
                    this.filedataformlist.push(this.filedataformitemlist);

                    //Remove Disabled Attribute
                    element.target.removeAttribute('disabled');

                    //Send Data for Storage File
                    return this.filedataformlist;

                }).catch((error) => {

                    throw new Error(error);

                });

            });

        },
        sendData(formaction, data = null, element = null){

            //Disabled BTN
            this.disabled = true;

            //Active Loading
            document.querySelector('.loadingbase').classList.add('d-flex');

            //Structure Data Form
            let dataForm = {};

            //Set Route
            let method;
            let urlmethod; 

            switch(formaction)
            {
                //Insert
                case 'insert':

                    method = 'POST';
                    urlmethod = this.mediainsert;

                    //Set DataForm
                    dataForm.action = formaction;
                    dataForm.data = data;

                    //Check Data for insert route
                    if(dataForm.data.length === 0){

                        //Send Message
                        alert('Por favor apenas enviar dados válidos');

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Enableds BTN
                        this.disabled = false;

                        return;

                    }

                break;

            }

            //Check Data Form
            if(Object.keys(dataForm).length > 0){

                //Send Data
                let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);

                //Check Response
                response.then((value) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Generate a Response
                    return this.dataStructureResponse(value);

                }).catch((error) => {

                    alert('Ocorreu um erro ao executar sua requisição é necessário fazer o reload da Página');

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enableds BTN
                    this.disabled = false;

                    throw new Error(error);

                });

            }else{

                //Send Message
                alert('Por favor apenas enviar dados válidos');

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                //Enableds BTN
                this.disabled = false;

            }

            return;

        }

    },
    computed:{

        computedFileAlt(){

            return this.filealt;

        },
        computedFiledataFormList(){

            return this.filedataformlist;

        },
        computedFileFormItemList(){

            return this.filedataformitemlist;

        },
        computedFileWidthHeightList(){

            return this.filewidthheightlist;

        }

    },
    watch:{

        computedFileAlt(){},
        computedFiledataFormList(){},
        computedFileFormItemList(){},
        computedFileWidthHeightList(){}

    },
    components:{


    }


}

</script>